import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ArrowIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '35%' : '50%'}
      height={circled ? '35%' : '50%'}
      viewBox="0 0 11.811 10.121"
    >
      <g transform="translate(-53.439 -668.645)">
        <line
          x2="10"
          transform="translate(54.5 673.705)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <g transform="translate(-2158.242 -11.037)">
          <line
            x1="4"
            y2="4"
            transform="translate(2216.742 684.742) rotate(90)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            x1="4"
            y1="4"
            transform="translate(2216.742 680.742) rotate(90)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
